<script>
import { Line } from "vue-chartjs";
import numberFormatter from "@/utils/numberFormatter.js";
import { parseToMoney } from "@/utils/currency";
import moment from "moment";

export default {
    name: "CardGraphCashFlow",
    extends: Line,
    data() {
        return {
            notRenderedYet: true,
            options: {
                scales: {
                    yAxes: [
                        {
                            ticks: {
                                beginAtZero: true,
                                fontColor: "#272727",
                                fontFamily: "Open Sans",
                                callback: (value) => numberFormatter(value, 2),
                            },
                            gridLines: {
                                display: true,
                                zeroLineWidth: 1.5,
                                zeroLineColor: "#272727",
                            },
                        },
                    ],
                    xAxes: [
                        {
                            type: "time",
                            time: {
                                unit: "week",
                                displayFormats: {
                                    week: "DD-MMM",
                                },
                            },
                            gridLines: {
                                color: "#EFEFEF",
                            },
                            ticks: {
                                fontColor: "#6A6B6D",
                                fontFamily: "Open Sans",
                            },
                        },
                    ],
                },
                tooltips: {
                    enabled: true,
                    callbacks: {
                        title: (tooltipItem) => {
                            return moment(tooltipItem[0].xLabel).format(
                                "DD-MMM-YYYY"
                            );
                        },
                        label: (tooltipItem, data) => {
                            var label =
                                data.datasets[tooltipItem.datasetIndex].label ||
                                "";
                            return (
                                label + ": " + parseToMoney(tooltipItem.yLabel)
                            );
                        },
                        fontSize: 13,
                    },
                },
                legend: {
                    labels: {
                        fontColor: "#272727",
                    },
                },
                responsive: true,
                maintainAspectRatio: false,
            },
        };
    },
    props: {
        chartObject: {
            type: Object,
            default: null,
        },
        isVisible: Boolean,
    },
    methods: {
        callRenderChart() {
            const vm = this;
            const moreOptions = {
                animation: {
                    duration: 400,
                    onComplete: function() {
                        vm.$emit('onChartRendered');
                    },
                }
            };
            this.options = {
                ...this.options,
                ...moreOptions
            };
            this.renderChart(
                {
                    labels: this.chartObject.labels,
                    datasets: [
                        {
                            label: "Cuentas Bancarias",
                            type: "line",
                            borderColor: "#5A4CD3",
                            pointBackgroundColor: "#5A4CD3",
                            pointRadius: 3.5,
                            borderWidth: 2.3,
                            pointBorderColor: "#5A4CD3",
                            backgroundColor: "transparent",
                            data: this.chartObject.balance,
                        },
                        {
                            label: "Por pagar",
                            type: "bar",
                            stack: "now",
                            borderColor: "#B53886",
                            pointBackgroundColor: "#E1AFCF",
                            borderWidth: 1.8,
                            barThickness: 35,
                            pointBorderColor: "#E1AFCF",
                            backgroundColor: "#E1AFCF",
                            data: this.chartObject.pagar,
                        },
                        {
                            label: "Por cobrar",
                            type: "bar",
                            stack: "now",
                            borderColor: "#00A9AD",
                            pointBackgroundColor: "#99DDDE",
                            borderWidth: 1.8,
                            barThickness: 35,
                            pointBorderColor: "#99DDDE",
                            backgroundColor: "#99DDDE",
                            data: this.chartObject.cobrar,
                        },
                    ],
                },
                this.options
            );
        },
    },
    mounted() {
        if (this.isVisible) {
            this.callRenderChart();
        }
    },
    watch: {
        chartObject: {
            handler: function () {
                this.callRenderChart();
            },
        },
        isVisible(newVal) {
            if (newVal && this.notRenderedYet) {
                this.$nextTick(() => {
                    this.callRenderChart();
                });
                this.notRenderedYet = false;
            }
        },
    },
};
</script>
